import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Logo from "../assests/Logo.webp";
import authService, { getsitedata, verifyAuth } from "../services/authservices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ScaleLoader } from "react-spinners";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  ListItem,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Menu from "@material-ui/core/Menu";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { getUserDetails } from "../services/authservices";
import Joyride from "react-joyride";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import isValidPhoneNumber from "libphonenumber-js/min";
import authservices from "../services/authservices";

import CookieConsent from "react-cookie-consent";
import LanguageIcon from "@mui/icons-material/Language";

import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

// import { useAppKit } from '@reown/appkit/react';
// import {
//   useWeb3Modal,
//   useWeb3ModalAccount,
//   useWeb3ModalProvider,
// } from "@web3modal/ethers/react";
// import {
//   BrowserProvider,
//   Contract,
//   formatUnits,
//   JsonRpcProvider,
// } from "ethers";
// import { ethers } from "ethers";
// import Web3 from "web3";

dayjs.extend(relativeTime);
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [NotiEl, setNotiEl] = useState(null);
  const isHomePage = window.location.pathname === "/";
  const istermsCondition = window.location.pathname === "/termscondition";
  const isprivacypolicy = window.location.pathname === "/privacypolicy";
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { login } = useContext(UserContext);
  const [toastVisible, setToastVisible] = useState(false);
  const navigate = useNavigate();

  const [loginCheck, setloginCheck] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const isActiatedFree = localStorage.getItem("freemiumActivated") || "false";
  const { theme, toggleTheme } = useContext(UserContext);
  // const { I18nextLng, setI18nextLng } = useContext(UserContext);
  const location = useLocation();
  const classes = useStyles();
  const { logout } = useContext(UserContext);

  const [hasUnread, setHasUnread] = useState(false);
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    emailStatus: 0,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    isAuthenticated: false,
    botStatus: "DeActive",
    profile_image: "",
  });

  const [viewTranslate, setviewTranslate] = useState(false);
  const [contactLoading, setcontactLoading] = useState(false);

  const walletneed = async () => {
    try {
      if (!toastVisible) {
        setToastVisible(true); // Set toast as visible
        toast.warn(
          <div className="toast-ml">
            <h4 className="toast-title">Oops!</h4>
            <p className="toast-message">{"Connect Wallet to continue!"}</p>
          </div>,
          {
            onClose: () => setToastVisible(false), // Reset toastVisible on close
            autoClose: 3000, // Optional: auto-close after 3 seconds
          }
        );
      }
    } catch (error) {
      // console.log(error, "0000000000000000");
    }
  };

  const [run, setRun] = useState(false);
  const [emailPopup, setEmailPopup] = useState(false);
  const [verifyEmailPopup, setVerifyEmailPopup] = useState(false);
  const [userVerifyEmail, setuserVerifyEmail, userVerifyEmailref] = useState(1);
  const [headerLoader, setheaderLoader, headerLoaderref] = useState(true);
  const [notificationPopup, setnotificationPopup] = useState(false);
  const fetchUserDetails = async () => {
    // console.log("000000000000000077777");
    setheaderLoader(true);
    const token = localStorage.getItem("token");
    if (token) {
      setUser({
        isAuthenticated: true,
      });
      setheaderLoader(false);
      // console.log(user.isAuthenticated, "user.isAuthenticated");
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            emailStatus: data.emailStatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            botStatus: data.botStatus,
            profile_image: data.profile_image,
          };
          setUser(userDetails);
          setuserVerifyEmail(data.emailStatus);
          // console.log(
          //   data,
          //   "Home response here ---->>>>>",
          //   userVerifyEmailref.current
          // );
          const hasSeenPopup = localStorage.getItem("hasSeenEmailPopup");
          const hasSeenVerifyPopup = localStorage.getItem(
            "hasSeenEmailVerifyPopup"
          );
          // console.log(
          //   hasSeenVerifyPopup,
          //   hasSeenPopup,
          //   "hasSeenVerifyPopup hasSeenPopup data.emailStatus",
          //   data.emailStatus
          // );
          const userLogin = localStorage.getItem("userlogin");
          if (userLogin === "true") {
            setRun(true);
          } else {
            if (!userDetails?.email || userDetails?.email == "N/A") {
              if (token && !hasSeenPopup) {
                setEmailPopup(true);
                // localStorage.setItem("hasSeenEmailPopup", "true"); // Mark popup as shown
              }
            } else if (
              data.emailStatus == 0 &&
              !hasSeenVerifyPopup &&
              location.pathname === "/home"
            ) {
              setVerifyEmailPopup(true);
              sessionStorage.setItem("hasSeenEmailVerifyPopup", "true");
            }
          }
        } else {
          setheaderLoader(false);

          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
            botStatus: "DeActive",
            profile_image: null,
          });
        }
      } catch (error) {
        setheaderLoader(false);

        // console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
          botStatus: "DeActive",
          profile_image: null,
        });
      }
    } else {
      setheaderLoader(false);
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        botStatus: "DeActive",
        profile_image: null,
      });
    }
    setLoading(false);
    setheaderLoader(false);
  };

  const closePopup = () => {
    setEmailPopup(false);
  };

  const closeVerifyPopup = () => {
    setVerifyEmailPopup(false);
  };
  useEffect(() => {
    if (location.pathname !== "/home") {
      setVerifyEmailPopup(false);
    }
    // console.log("location.pathname", location.pathname);
    if (
      location.pathname == "/" ||
      location.pathname == "/et" ||
      location.pathname == "/fi"
    ) {
      setviewTranslate(true);
    } else {
      setviewTranslate(false);
    }
  }, [location.pathname]);

  const proceedToProfile = () => {
    setEmailPopup(false);
    navigate("/profile");
    localStorage.setItem("hasSeenEmailPopup", "true");
    localStorage.setItem("hasSeenEmailVerifyPopup", "true");
  };

  const close_popup = () => {
    setnotificationPopup(false);
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    // console.log(userToken, "userToken");
    if (userToken == null || userToken == "" || userToken == undefined) {
      setheaderLoader(false);
    } else {
      checkuserAuth();
    }
  }, [0]);

  const container =
    window !== undefined ? () => window().document.body : undefined;

  // const { chainId, isConnected } = useWeb3ModalAccount();

  // const { open, close } = useWeb3Modal();
  // const { open } = useAppKit()
  // const { disconnect } = useDisconnect();
  // const { walletProvider } = useWeb3ModalProvider();

  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isConnectedBoo, setisConnected, isConnectedBooref] = useState(false);
  const [validWallet, setValidWallet] = useState(false);

  const [openpopup, setOpenpopup] = useState(false);
  const handleOpen = () => setOpen(true);

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const showWarningToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Oops!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const BSC_TESTNET_CHAIN_ID = 97;

  const [dropstatus, setdropstatus] = useState(false);

  const dropdowns = async () => {
    // console.log(dropstatus, "dropstatus");
    if (dropstatus == true) {
      setdropstatus(false);
    } else {
      setdropstatus(true);
    }
  };

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await verifyAuth(token);
        // console.log("token verify data --->>", data);
        if (data.status === 401 || data.Message === "TokenExpired") {
          handleLogout();
          // await disconnect();
          showerrorToastExpired(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">
                Session expired. Please log in again.
              </p>
            </div>
          );
        } else {
          // console.log("Token is valid");
        }
      } catch (error) {
        // console.error("Error auth user details:", error);
        handleLogout();
      }
    }
  };

  // useEffect(() => {
  //   document.body.classList.add(theme); // Apply the current theme to the body element (or another container)
  // }, [theme]);

  useEffect(() => {
    document.body.classList.add("dark"); // Apply the current theme to the body element (or another container)
  }, [0]);

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    // console.log("----uuuuu", userToken);

    if (userToken == null || userToken == "" || userToken == undefined) {
      setheaderLoader(false);
    } else {
      // console.log("----", userToken);
      setUser({
        isAuthenticated: true,
      });
      fetchUserDetails();
      getnotify();
    }
  }, []);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClose1 = () => {
    setNotiEl(null);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getnotify = async () => {
    try {
      const response = await authService.getNotification();
      // console.log("response-->", response.data);
      if (response.status) {
        setLoginHistory(response.data.data.data);
        const hasUnreadNotifications = response.data.data.data.some(
          (n) => n.status === 0
        );
        //  console.log("hasUnreadNotifications--->>>>",hasUnreadNotifications);
        setHasUnread(hasUnreadNotifications); // Update state

        const hasadminNotifications =
          response.data.data.admin_notification.some(
            (n) => n.status === 0 && n.admin_status === 1
          );

        if (hasadminNotifications) {
          setnotificationPopup(true);
          setAdminNotification(response.data.data.admin_notification[0]);
          // console.log(
          //   "hasadminNotifications--->>>>",
          //   AdminNotificationref.current
          // );
        }
      }
    } catch (error) {}
  };

  const handleClick1 = async (event) => {
    setNotiEl(event.currentTarget);
    const response = await authService.notifyStateChange();
    if (response.status) {
      setHasUnread(false); // Remove the bell indicator
      getnotify();
    }
  };

  // const handleThemeToggle = () => {
  //   // window.location.reload();
  //   setTheme((prevTheme) => {
  //     const newTheme = prevTheme === "dark" ? "light" : "dark";
  //     localStorage.setItem("theme", newTheme); // Save to localStorage for persistence
  //     return newTheme;
  //   });
  // };

  useEffect(() => {
    // Whenever the theme is toggled, we update the body class.
    // This ensures the theme change is applied globally on the page.
    document.body.className = theme; // Update body class according to the theme
  }, [theme]);

  // useEffect(() => {
  //   document.body.setAttribute("data-theme", theme); // Set the theme attribute on <body>
  // }, [theme]);
  // useEffect(() => {
  //   if (theme === 'dark') {
  //     document.body.classList.add('dark');
  //     document.body.classList.remove('light');
  //   } else {
  //     document.body.classList.add('light');
  //     document.body.classList.remove('dark');
  //   }
  //   localStorage.setItem('theme', theme);
  // }, [theme])

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setheaderLoader(false);
      setloginCheck(false);
    }
  }, []);

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  const obfuscateEmail = (email) => {
    if (!email) return "";
    const [localPart, domainPart] = email.split("@");
    const firstFive = localPart.slice(0, 3);
    return `${firstFive}***@${domainPart}`;
  };

  const [open1, setOpen] = useState(false);

  const notifyNav = () => {
    navigate("/history");
  };
  const copyToClipboard = (() => {
    let toastVisible = false;
    let timeout = null;

    return (text) => {
      if (toastVisible) return;

      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toastVisible = true;
            toast.success(
              <div className="toast-ml">
                <h4 className="toast-title">Success!</h4>
                <p className="toast-message">UID code Copied!</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          })
          .catch((err) => {
            // console.error("Failed to copy text:", err);
            toastVisible = true;
            toast.error(
              <div className="toast-ml">
                <h4 className="toast-title">Error!</h4>
                <p className="toast-message">Failed to copy code</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          });
      }, 300);
    };
  })();

  const handleLogout = async () => {
    await logout();
    document.cookie =
      "myAwesomeCookieName2=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.clear();
    navigate("/");
    setheaderLoader(false);
    user.isAuthenticated = false;
    // toast.error("Logout Successfully!");
    window.location.reload();
    toast.dismiss();
    // showSuccessToast("Wallet Disconnected");
  };

  const [loginHistory, setLoginHistory, loginHistoryref] = useState([]);
  const [AdminNotification, setAdminNotification, AdminNotificationref] =
    useState([]);
  const handleLogin = () => {
    navigate("/login");
  };
  const handleRegister = () => {
    navigate("/register");
  };

  const showerrorToastExpired = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  // useEffect(() => {
  //   const fetchLoginHistory = async () => {
  //     const response = await authService.getLoginHistory();
  //     if (response.status) {
  //       setLoginHistory(response.data.slice(0, 5)); // Limit to 5 records
  //     } else {
  //       console.error("Failed to fetch login history:", response.Message);
  //     }
  //     setLoading(false);
  //   };

  //   fetchLoginHistory();
  // }, []);

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  const steps = [
    {
      target: ".home-link",
      content: (
        <div>
          <h3>Create Account</h3>
          <p>
            Get started by creating your account in just a few clicks using your
            email.
          </p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
      spotlightClicks: false,
      disableOverlayClose: true,
    },
    {
      target: ".deposit-link",
      content: (
        <div>
          <h3>Deposit Amount</h3>
          <p>
            Securely fund your wallet with crypto and prepare for automated
            trading.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".upgrade-link",
      content: (
        <div>
          <h3>Plan Upgrade</h3>
          <p>
            User has the opportunity to renew his plan either for free or for a
            cost.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".apibind-link",
      content: (
        <div>
          <h3> Enable Exchange</h3>
          <p>
            Connect your preferred exchange by adding your API and secret keys.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".bottrade-link",
      content: (
        <div>
          <h3> Activate Bot</h3>
          <p>
            Turn on your trading bot, manage your portfolio, and let it work for
            you.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".withdraw-link",
      content: (
        <div>
          <h3>Withdraw Profits</h3>
          <p>
            Seamlessly transfer your profits anytime with a few simple steps.
          </p>
        </div>
      ),
      placement: "bottom",
    },
  ];

  // contact modal
  const [contactOpen, setContactOpen] = useState(false);
  const handleContactOpen = () => setContactOpen(true);
  const handleContactClose = () => setContactOpen(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    countryCode: "",
    country: "",
    dialCode: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [phone, setPhone] = useState("");
  const [phoneerror, setPhoneError] = useState("");
  const [country, setCountry] = useState("in"); // default to India

  const handleChange = (value, data) => {
    // console.log(data, "-----");
    setPhone(value);
    setCountry(data.countryCode); // e.g., "in", "us", "fr"
    validatePhone(value, data.countryCode);
    setFormData({
      ...formData,
      phoneNumber: value,
      countryCode: data.countryCode,
      dialcode: data.dialCode,
      country: data.name,
    });
  };

  const validatePhone = (number, countryCode) => {
    const parsedNumber = `+${number}`;
    try {
      if (!formData.phoneNumber) {
        setPhoneError("Phone Number is required.");
      }
      const isValid = isValidPhoneNumber(
        parsedNumber,
        countryCode.toUpperCase()
      );
      if (!isValid) {
        setPhoneError("Invalid phone number for selected country.");
      } else {
        setPhoneError("");
      }
    } catch (err) {
      setPhoneError("Validation error: " + err.message);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Individual field validation
    let newErrors = { ...errors };
    if (name === "name") {
      if (!value) newErrors.name = "User Name is required";
      else if (value.length < 5)
        newErrors.name = "Name cannot below 5 characters";
      else if (value.length > 25)
        newErrors.name = "Name cannot exceed 25 characters";
      else delete newErrors.name;
    } else if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) newErrors.email = "Email is required";
      else if (!emailRegex.test(value))
        newErrors.email = "Invalid email format";
      else if (value.length > 250)
        newErrors.email = "Email cannot exceed 250 characters";
      else delete newErrors.email;
    }
    if (name === "message") {
      if (!value) newErrors.message = "Message is required";
      else if (value.length < 5)
        newErrors.message = "Message cannot below 5 characters";
      else if (value.length > 250)
        newErrors.message = "Message cannot exceed 250 characters";
      else delete newErrors.message;
    }

    setErrors(newErrors);
  };

  const handleKeyDown = (e, type) => {
    if (type === "email") {
      const regex = /^[a-zA-Z0-9@._-]+$/;
      if (
        !regex.test(e.key) ||
        (e.target.value.length >= 250 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    }
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&.]{12,30}$/;
    const referralCodeRegex = /^[a-zA-Z0-9]{1,13}$/;

    // console.log("formData reg --->>", formData, "newErrors --->>", newErrors);

    if (!formData.name) {
      newErrors.name = "User Name is required";
    } else if (formData.name.length < 5) {
      newErrors.name = "Name cannot below 5 characters";
    } else if (formData.name.length > 25) {
      newErrors.name = "Name cannot exceed 25 characters";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    } else if (formData.email.length > 250) {
      newErrors.email = "Email cannot exceed 250 characters";
    }
    const isValid = isValidPhoneNumber(
      formData.phoneNumber,
      formData.countryCode.toUpperCase()
    );
    if (!formData.phoneNumber) {
      setPhoneError("Phone Number is required.");
    } else if (!isValid) {
      setPhoneError("Invalid phone number for selected country.");
    } else {
      setPhoneError("");
    }
    if (!formData.message) {
      newErrors.message = "Message is required";
    } else if (formData.message.length > 250) {
      newErrors.message = "message cannot exceed 250 characters";
    }
    setErrors(newErrors);
    return newErrors;
  };
  const formEmpty = async () => {
    setFormData({
      ...formData,
      phoneNumber: "",
      countryCode: "",
      dialcode: "",
      country: "",
      name: "",
      email: "",
      message: "",
    });
    setPhone("");
    setCountry("");
  };
  const submitform = async (e) => {
    try {
      e.preventDefault();
      // console.log(formData);
      const validationErrors = validate();
      // console.log(Object.keys(validationErrors).length, "validationErrors");
      if (Object.keys(validationErrors).length > 0 || phoneerror != "") {
        setErrors(validationErrors);
        validate();
      } else {
        setcontactLoading(true);
        const response = await authService.contactForm(formData);
        if (response.status) {
          // showSuccessToast(response.Message);
          setcontactLoading(false);
          formEmpty();
          handleContactClose();
          toast.success(response.Message);
        } else {
          showErrorToast(response.Message);
          formEmpty();
        }
      }
    } catch (error) {}
  };

  const { t } = useTranslation();
  const { i18nextLng } = useContext(UserContext);
  const { lang: urlLang } = useParams();

  const initialLang = localStorage.getItem("i18nextLng") || "en";

  const [lang, setLang] = useState(initialLang);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (initialLang) {
      i18n.changeLanguage(initialLang);
      document.documentElement.lang = initialLang;
    }
  }, [initialLang]);

  useEffect(() => {
    setLang(initialLang);
  }, [initialLang]);

  // const changeLang = (newLang) => {
  //   console.log(newLang, "newLang===");

  //   setLang(newLang);

  //   const location = window.location;
  //   const currentPath = location.pathname;
  //   const searchParams = new URLSearchParams(location.search);

  //   if (newLang === "en") {
  //     searchParams.delete("lang");
  //   } else {
  //     searchParams.set("lang", newLang);
  //   }

  //   const newUrl =
  //     currentPath +
  //     (searchParams.toString() ? `?${searchParams.toString()}` : "");

  //   navigate(newUrl, { replace: true });

  //   setShowPopup(false);
  //   localStorage.setItem("i18nextLng", newLang);
  // };

  const changeLang = (newLang) => {
    console.log(newLang, "newLang===");

    setLang(newLang);

    const location = window.location;
    let currentPath = location.pathname;

    let parts = currentPath.split("/").filter(Boolean);
    const lastPart = parts[parts.length - 1];

    if (["en", "et", "fi"].includes(lastPart)) {
      parts.pop();
    }

    parts.push(newLang);

    const newUrl = "/" + parts.join("/");

    navigate(newUrl, { replace: true });

    setShowPopup(false);
    localStorage.setItem("i18nextLng", newLang);
  };

  return (
    <div>
      <header className="scrolled">
        <div>
          <div className={`${classes.root} `}>
            <AppBar position="static">
              <Toolbar className="container-fluid pad-0 w-100">
                <Typography variant="h6" className={classes.title}>
                  <div className="d-flex">
                    <Link to="/" className="logo-brand">
                      <img src={Logo} className="img-fluid" alt="logo" />
                    </Link>
                    <div className={`menu_new_typr ${classes.appBarItems}`}>
                      {/* <Link to="/" color="inherit" className="contact_button"> */}
                      {/* {user.isAuthenticated ? ( */}
                      {/* <Link
                        to={user.isAuthenticated ? "/home" : "/login"}
                        color="inherit"
                        className={`${isActive("home")} home-link`}
                      >
                        Home
                      </Link> */}
                      {/* ) : (
                        <Link
                          onClick={walletneed}
                          to={user.isAuthenticated ? "/" : "/"}
                        >
                          Home
                        </Link>
                      )} */}
                      {loginCheck == true ? (
                        <>
                          <Link to="/home" color="inherit">
                            {t("Home")}
                          </Link>
                          {/* <Link
                            to={user.isAuthenticated ? "/login" : "/deposit"}
                            color="inherit"
                            className={`${isActive("deposit")} deposit-link`}
                          >
                            {t("Deposit")}
                          </Link> */}

                          <Link
                            to="/deposit"
                            color="inherit"
                            className={`${isActive("deposit")} deposit-link`}
                          >
                            {t("Deposit")}
                          </Link>

                          <Link
                            to={user.isAuthenticated ? "/withdraw" : "/login"}
                            color="inherit"
                            className={`${isActive("withdraw")} withdraw-link`}
                          >
                            {t("Withdraw1")}
                          </Link>

                          {/* <Link
                              to={user.isAuthenticated ? "/strategies" : "/login"}
                              color="inherit"
                              className={`${isActive("strategies")} withdraw-link`}
                            >
                              Strategies
                            </Link> */}

                          <Link
                            to={
                              user.isAuthenticated
                                ? "/transferwallet"
                                : "/login"
                            }
                            color="inherit"
                            className={`${isActive("transferwallet")}`}
                          >
                            {t("Transfer")}
                          </Link>

                          <Link
                            to={user.isAuthenticated ? "/upgrade" : "/login"}
                            color="inherit"
                            className={`${isActive("upgrade")} upgrade-link`}
                          >
                            {t("Upgrade")}
                          </Link>

                          <Link
                            to={user.isAuthenticated ? "/apibind" : "/login"}
                            color="inherit"
                            className={`${isActive("apibind")} apibind-link`}
                          >
                            {t("APIBinding")}
                          </Link>

                          <Link
                            to={
                              user.isAuthenticated
                                ? "/bottradehistory"
                                : "/login"
                            }
                            color="inherit"
                            className={`${isActive(
                              "bottradehistory"
                            )} bottrade-link`}
                          >
                            {t("BotTrade")}
                          </Link>

                          {/* <Link
                            to={
                              user.isAuthenticated
                                ? "/balance-history"
                                : "/login"
                            }
                            color="inherit"
                            className={`${isActive("balance-history")}`}
                          >
                            {t("BotBalance")}
                          </Link> */}

                          <Link
                            to={user.isAuthenticated ? "/referral" : "/login"}
                            color="inherit"
                            className={`${isActive("referral")}`}
                          >
                            {t("ReferEarn")}
                          </Link>
                        </>
                      ) : (
                        <>
                          <Link to="/" color="inherit">
                            {t("Home")}
                          </Link>
                          <a href="#how-it-works" color="inherit">
                            {t("HowItWorks")}
                          </a>
                          <a href="#pricing" color="inherit">
                            {t("Pricing")}
                          </a>
                          <a href="/about-us" color="inherit">
                            {t("Aboutus")}
                          </a>
                          <a href="/affiliate" color="inherit">
                            {t("Affiliate")}
                          </a>
                          <a href="/faq" color="inherit">
                            {t("FAQ")}
                          </a>

                          <a
                            className="dropdown-item "
                            href="/guides-tutorials"
                          >
                            {t("GuidesTutorials")}
                          </a>

                          {/* <div
                            className="hd_contact_link"
                            color="inherit"
                            onClick={handleContactOpen}
                          >
                            Contact
                          </div>

                          <Modal
                            keepMounted
                            open={contactOpen}
                            onClose={handleContactClose}
                            aria-labelledby="keep-mounted-modal-title"
                            aria-describedby="keep-mounted-modal-description"
                          >
                            <Box sx={style} className="hd_contact_box">
                              <div className="hd_contact_box_inner">
                                <div className="hd_contact_top">
                                  <h6>Contact Us</h6>
                                  <span onClick={handleContactClose}>
                                    <i className="fa-solid fa-xmark"></i>
                                  </span>
                                </div>
                                <form className="hd_contact_form">
                                  <div className="hd_contact_flex_wrap">
                                    <div className="hd_contact_flx">
                                      <label
                                        htmlFor="userName"
                                        className="hd_contact_label"
                                      >
                                        Name
                                      </label>
                                      <input
                                        type="text"
                                        id="userName"
                                        value={formData.name}
                                        name="name"
                                        placeholder="Enter your name"
                                        maxLength={25}
                                        className="hd_contact_input"
                                        autoComplete="off"  onChange={handleInputChange}
                                         onKeyDown={(e) => handleKeyDown(e, "name")}
                                      />
                                        {errors.name && (
                                 <span className="error">{errors.name}</span>
                                  )}
                                    </div>
                                    <div className="hd_contact_flx">
                                      <label
                                        htmlFor="userEmail"
                                        className="hd_contact_label"
                                      >
                                        Email
                                      </label>
                                      <input
                                        type="emal"
                                        id="userEmail"
                                        value={formData.email}
                                        name="email"
                                        placeholder="Enter your email address"
                                        className="hd_contact_input"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                         onKeyDown={(e) => handleKeyDown(e, "email")}
                                      />
                                        {errors.email && (
                              <span className="error">{errors.email}</span>
                            )}
                                    </div>
                                    <div className="hd_contact_flx">
                                      <label
                                        htmlFor="userEmail"
                                        className="hd_contact_label"
                                      >
                                        Mobile Number
                                      </label>
                                    
                                       <PhoneInput
                                          country={"in"}
                                          value={phone}
                                          onChange={handleChange}
                                          className="hd_phone_input"
                                          enableSearch={true}
                                           />
                                           {phoneerror && (
                              <span className="error">{phoneerror}</span>
                            )}
                                    </div>
                                    <div className="hd_contact_flx">
                                      <label
                                        htmlFor="userMessage"
                                        className="hd_contact_label"
                                      >
                                        Message
                                      </label>
                                      <textarea
                                        type="text"
                                        id="userMessage"
                                        placeholder="Enter your name"
                                        className="hd_contact_input hd_cnt_txtarea"
                                        autoComplete="off"
                                         value={formData.message}
                                         maxLength={250}
                                        name="message"
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleKeyDown(e, "message")}
                                      ></textarea>
                                       {errors.message && (
                              <span className="error">{errors.message}</span>
                            )}
                                    </div>
                                  </div>

                                  <button className="hd_contact_btn" onClick={submitform}>
                                    Submit
                                  </button>
                                </form>
                              </div>
                            </Box>
                          </Modal> */}
                        </>
                      )}
                      <div
                        className="hd_contact_link"
                        color="inherit"
                        onClick={handleContactOpen}
                      >
                        {t("Contact10")}
                      </div>

                      <Modal
                        keepMounted
                        open={contactOpen}
                        onClose={handleContactClose}
                        aria-labelledby="keep-mounted-modal-title"
                        aria-describedby="keep-mounted-modal-description"
                      >
                        <Box sx={style} className="hd_contact_box">
                          <div className="hd_contact_box_inner">
                            <div className="hd_contact_top">
                              <h6>{t("ContactUs")}</h6>
                              <span onClick={handleContactClose}>
                                <i className="fa-solid fa-xmark"></i>
                              </span>
                            </div>
                            <form className="hd_contact_form">
                              <div className="hd_contact_flex_wrap">
                                <div className="hd_contact_flx">
                                  <label
                                    htmlFor="userName"
                                    className="hd_contact_label"
                                  >
                                    {t("Name")}
                                  </label>
                                  <input
                                    type="text"
                                    id="userName"
                                    value={formData.name}
                                    name="name"
                                    // placeholder="Enter your name"
                                    maxLength={25}
                                    className="hd_contact_input"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => handleKeyDown(e, "name")}
                                  />
                                  {errors.name && (
                                    <span className="error">{errors.name}</span>
                                  )}
                                </div>
                                <div className="hd_contact_flx">
                                  <label
                                    htmlFor="userEmail"
                                    className="hd_contact_label"
                                  >
                                    {t("Email")}
                                  </label>
                                  <input
                                    type="emal"
                                    id="userEmail"
                                    value={formData.email}
                                    name="email"
                                    // placeholder="Enter your email address"
                                    className="hd_contact_input"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => handleKeyDown(e, "email")}
                                  />
                                  {errors.email && (
                                    <span className="error">
                                      {errors.email}
                                    </span>
                                  )}
                                </div>
                                <div className="hd_contact_flx">
                                  <label
                                    htmlFor="userEmail"
                                    className="hd_contact_label"
                                  >
                                    {t("MobileNumber")}
                                  </label>

                                  <PhoneInput
                                    country={"in"}
                                    value={phone}
                                    onChange={handleChange}
                                    className="hd_phone_input"
                                    enableSearch={true}
                                  />
                                  {phoneerror && (
                                    <span className="error">{phoneerror}</span>
                                  )}
                                </div>
                                <div className="hd_contact_flx">
                                  <label
                                    htmlFor="userMessage"
                                    className="hd_contact_label"
                                  >
                                    {t("Message")}
                                  </label>
                                  <textarea
                                    type="text"
                                    id="userMessage"
                                    // placeholder="Enter your name"
                                    className="hd_contact_input hd_cnt_txtarea"
                                    autoComplete="off"
                                    value={formData.message}
                                    maxLength={250}
                                    name="message"
                                    onChange={handleInputChange}
                                    onKeyDown={(e) =>
                                      handleKeyDown(e, "message")
                                    }
                                  ></textarea>
                                  {errors.message && (
                                    <span className="error">
                                      {errors.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                              {contactLoading ? (
                                <button className="hd_contact_btn">
                                  {t("Loading")}
                                </button>
                              ) : (
                                <button
                                  className="hd_contact_btn"
                                  onClick={submitform}
                                >
                                  {t("Submit")}
                                </button>
                              )}
                            </form>
                          </div>
                        </Box>
                      </Modal>
                      {/* <Link
                        to={user.isAuthenticated ? "/withdraw" : "/login"}
                        color="inherit"
                        className={`${isActive("withdraw")} withdraw-link`}
                      >
                        Guides & Tutorials
                      </Link>
                      <Link
                        to={user.isAuthenticated ? "/withdraw" : "/login"}
                        color="inherit"
                        className={`${isActive("withdraw")} withdraw-link`}
                      >
                        Blog
                      </Link> */}

                      {/* <div class="dropdown hd_nav_dropdown">
                        <button
                          className="dropdown-toggle hd_nav_drp_toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          More
                        </button>
                        <ul class="dropdown-menu hd_nav_drp_menu">
                          <li>
                            <Link className="dropdown-item mx-0" to="/blog">
                              Blog
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item mx-0"
                              to="/guides-tutorials"
                            >
                              Guides & Tutorials
                            </Link>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </div>
                </Typography>

                {headerLoader == true ? (
                  ""
                ) : (
                  <>
                    <div
                      className={`menu_new_typr_right ${classes.appBarItems}`}
                    >
                      {!user.isAuthenticated ? (
                        <>
                          <Link to="/login">
                            <button
                              className="head-btn-login now_log"
                              style={{ width: "120px" }}
                            >
                              <span className="head-btn-login-now now_log">
                                {t("Login")}
                              </span>
                              <span className="head-btn-login-new">
                                {t("Login")}
                              </span>
                            </button>
                          </Link>
                          <Link to="/register">
                            <button
                              className="head-btn-login resp_100"
                              style={{ width: "120px" }}
                            >
                              <span className="head-btn-login-now">
                                {t("Registerpage")}
                              </span>
                              <span className="head-btn-login-new">
                                {t("Registerpage")}
                              </span>
                            </button>
                          </Link>
                        </>
                      ) : (
                        <>
                          <h6
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            className=" head-drops cursor-pointer"
                            onClick={handleClick1}
                          >
                            {/* {loginCheck ? ( */}
                            <img
                              src={require("../assests/icons/Notification.png")}
                              width="30px"
                              className="dark_display_none nav-primary-icons"
                            />
                            {hasUnread && (
                              <div className="bell-indicator"></div>
                            )}
                          </h6>
                          <Menu
                            id="simple-menu"
                            anchorEl={NotiEl}
                            keepMounted
                            open={Boolean(NotiEl)}
                            onClose={handleClose1}
                            className="MuiList-padding-notify"
                          >
                            {/* {loginCheck ? ( */}
                            <div className="frame-container notify-dropdown">
                              {/* user details */}
                              <div className="user-details-noti">
                                <div className="notify-contents">
                                  <div className="notify-head-wrapper d-flex align-items-center justify-content-between w-100">
                                    <h5>{t("Notifications")}</h5>
                                    <div
                                      className="d-flex align-items-center gap-2 cursor-pointer mt-3"
                                      onClick={notifyNav}
                                    >
                                      <span className="home_starty_view">
                                        {t("ViewAll")}
                                      </span>
                                      <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="noti_drop_margin">
                                {loading ? (
                                  <div className="loader_main loader_mainChange">
                                    <ScaleLoader
                                      color="#20A1FD"
                                      height={10}
                                      width={3}
                                    />
                                    <p>{t("Loading")}</p>
                                  </div>
                                ) : (
                                  loginHistoryref.current.map(
                                    (login, index) => (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center justify-content-between my-2 py-2"
                                      >
                                        <span className="top_startgy_inbottomadvance">
                                          {login.message}
                                        </span>
                                        <span className="noti_inner_right">
                                          {dayjs(login.createdAt).fromNow()}
                                        </span>
                                      </div>
                                    )
                                  )
                                )}
                              </div>
                            </div>
                            {/* ) : (
                        ""
                      )} */}
                          </Menu>
                          <h6
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            className=" head-drops cursor-pointer"
                            onClick={handleClick}
                          >
                            {/* {loginCheck ? ( */}
                            <img
                              src={require("../assests/icons/profile.png")}
                              width="30px"
                              className="dark_display_none nav-primary-icons"
                            />
                          </h6>

                          <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            className="MuiList-padding"
                          >
                            {/* {loginCheck ? ( */}
                            <div className="frame-container">
                              {/* user details */}
                              <div className="user-details">
                                {user.profile_image != null &&
                                user.profile_image != undefined &&
                                user.profile_image != "" ? (
                                  <img
                                    src={user.profile_image}
                                    alt="usericon"
                                    className="user-img"
                                  />
                                ) : (
                                  <img
                                    src={require("../assests/icons/home-user.png")}
                                    alt="usericon"
                                    className="user-img"
                                  />
                                )}
                                <div className="details">
                                  <span className="details-mail">
                                    {user.email}
                                  </span>
                                  <span className="details-udi">
                                    {t("UID")}: {user.uid}
                                    <i
                                      className="fa-regular fa-copy cursor-pointer"
                                      onClick={() => copyToClipboard(user.uid)}
                                      style={{
                                        color: "#20A1FD",
                                      }}
                                    ></i>
                                  </span>
                                </div>
                              </div>
                              {/* links */}
                              <ul className="links">
                                <li>
                                  <Link to="/profile" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/icons/user-icon.png")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span>{t("Profile")}</span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/deposit" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/icons/deposit-icon.png")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span>{t("Deposit")}</span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/withdraw" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/icons/withdraw-icon.png")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span className="hover">
                                        {t("Withdraw1")}
                                      </span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/transferwallet"
                                    className="link-content"
                                  >
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/transfer.webp")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span className="hover">
                                        {t("Transfer")}
                                      </span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>

                                {isActiatedFree === "false" && (
                                  <li>
                                    <Link
                                      to="/apibind"
                                      className="link-content"
                                    >
                                      <div className="head_link_flex">
                                        <img
                                          src={require("../assests/icons/api-bind.png")}
                                          // width="30px"
                                          className="nav-primary-icons-headinner"
                                        />
                                        <span>{t("APIBinding")}</span>
                                      </div>
                                      <span className="text_head_arrow hover-show">
                                        <i class="fa-solid fa-chevron-right"></i>
                                      </span>
                                    </Link>
                                  </li>
                                )}
                                <li>
                                  <Link to="/upgrade" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/upgrade.webp")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span>{t("Upgrade")} </span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/upgrade" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/upgrade.webp")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span>{t("BotTrade")} </span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>

                                {/* <li>
                                <Link to="/strategies" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/startegy-icon.png")}
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>{t("Strategies")} </span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li> */}

                                {/* <li>
                              <Link to="/team" className="link-content">
                                <div className="head_link_flex">
                                  <img
                                    src={require("../assests/icons/team-ico.png")}
                                    // width="30px"
                                    className="nav-primary-icons-headinner"
                                  />
                                  <span>Your Team</span>
                                </div>
                                <span className="text_head_arrow hover-show">
                                  <i class="fa-solid fa-chevron-right"></i>
                                </span>
                              </Link>
                            </li> */}

                                {/* <li>
                              <Link to="/poolhistory" className="link-content">
                                <div className="head_link_flex">
                                  <img
                                    src={require("../assests/icons/team-ico.png")}
                                    // width="30px"
                                    className="nav-primary-icons-headinner"
                                  />
                                  <span>Pool Progress</span>
                                </div>
                                <span className="text_head_arrow hover-show">
                                  <i class="fa-solid fa-chevron-right"></i>
                                </span>
                              </Link>
                            </li> */}
                                <li>
                                  <Link to="/security" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/icons/Security-icon.png")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span>{t("Security")}</span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/faq" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/icons/question-icon.png")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span> {t("FAQs")}</span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                                {/* <li>
                              <Link to="/policy" className="link-content">
                                <div className="head_link_flex">
                                  <img
                                    src={require("../assests/icons/policy-icon.png")}
                                    // width="30px"
                                    className="nav-primary-icons-headinner"
                                  />
                                  <span> Policy</span>
                                </div>
                                <span className="text_head_arrow hover-show">
                                  <i class="fa-solid fa-chevron-right"></i>
                                </span>
                              </Link>
                            </li> */}
                              </ul>
                              {/* logout button */}
                              {user.isAuthenticated && (
                                <div
                                  className="btn-wrapper security-link cursor-pointer"
                                  onClick={() => {
                                    // disconnect();
                                    handleLogout();
                                  }}
                                >
                                  <span className="user-btn">
                                    {t("Logout")}
                                  </span>
                                  <img
                                    src={require("../assests/logout.png")}
                                    alt="logoutimg"
                                    className="logout-img"
                                  />
                                </div>
                              )}
                            </div>
                          </Menu>

                          {/* {viewTranslate ? (
                          <div className="hd_lang_btn_wrap">
                            <button
                              className="hd_lang_btn"
                              onClick={() => setShowPopup(!showPopup)}
                            >
                              <LanguageIcon />
                            </button>

                            {showPopup && (
                              <div className="hd_lang_btn_menu">
                                <span onClick={() => changeLang("en")}>
                                  English
                                </span>
                                <span onClick={() => changeLang("et")}>
                                  Estonian
                                </span>
                                <span onClick={() => changeLang("fi")}>
                                  Finnish
                                </span>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )} */}
                        </>
                      )}

                      {/* {theme === "dark" ? (
                    <Link onClick={toggleTheme} className="contact_button">
                      <span className="theme-icons">
                        <i className="bi bi-brightness-high"></i>{" "}
                        Icon for light mode
                      </span>
                    </Link>
                  ) : (
                    <Link onClick={toggleTheme} className="contact_button">
                      <span className="theme-icons">
                        <i className="bi bi-moon"></i>{" "}
                        Icon for dark mode
                      </span>
                    </Link>
                  )} */}
                    </div>
                  </>
                )}
                   <div className="hd_lang_btn_wrap">
                  <button
                    className="hd_lang_btn"
                    onClick={() => setShowPopup(!showPopup)}
                  >
                    <LanguageIcon />
                  </button>

                  {showPopup && (
                    <div className="hd_lang_btn_menu">
                      <span onClick={() => changeLang("en")}>English</span>
                      <span onClick={() => changeLang("et")}>Estonian</span>
                      <span onClick={() => changeLang("fi")}>Finnish</span>
                    </div>
                  )}
                </div>
                <div className="mobile_change_header">
                  <div className="mobile-theme-icon">
                    {/* {theme == "dark" ? (
                    <Link
                      onClick={handleThemeToggle}
                      aclassName="contact_button"
                    >
                      <span className="theme-icons">
                        {" "}
                        <i clss="bi bi-brightness-high"></i>
                      </span>
                    </Link>
                  ) : (
                    <Link
                      onClick={handleThemeToggle}
                      className="contact_button"
                    >
                      <span className="theme-icons">
                        <i class="bi bi-moon"></i>
                      </span>
                    </Link>
                  )} */}

                    {/* {theme === "dark" ? (
                      <Link onClick={toggleTheme} className="contact_button">
                        <span className="theme-icons">
                          <i className="bi bi-brightness-high"></i>
                        </span>
                      </Link>
                    ) : (
                      <Link onClick={toggleTheme} className="contact_button">
                        <span className="theme-icons">
                          <i className="bi bi-moon"></i>
                        </span>
                      </Link>
                    )} */}
                  </div>
                  {user.isAuthenticated ? (
                    <div className="mobile-only">
                      <h6
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        className="head-drops cursor-pointer"
                        onClick={handleClick1}
                      >
                        <img
                          src={require("../assests/icons/Notification.png")}
                          width="30px"
                          className="dark_display_none nav-primary-icons"
                        />
                        {hasUnread && <div className="bell-indicator"></div>}
                      </h6>

                      <Menu
                        id="simple-menu"
                        anchorEl={NotiEl}
                        keepMounted
                        open={Boolean(NotiEl)}
                        onClose={handleClose1}
                        className="MuiList-padding-notify"
                      >
                        <div className="frame-container notify-dropdown">
                          <div className="user-details-noti">
                            <div className="notify-contents">
                              <div className="notify-head-wrapper d-flex align-items-center justify-content-between w-100">
                                <h5>{t("Notifications")}</h5>
                                <div
                                  className="d-flex align-items-center gap-2 cursor-pointer"
                                  onClick={notifyNav}
                                >
                                  <span className="home_starty_view">
                                    {t("ViewAll")}
                                  </span>
                                  <i className="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="noti_drop_margin">
                            {loading ? (
                              <div className="loader_main loader_mainChange">
                                <ScaleLoader
                                  color="#20A1FD"
                                  height={10}
                                  width={3}
                                />
                                <p>{t("Loading")}</p>
                              </div>
                            ) : (
                              loginHistoryref.current.map((login, index) => (
                                <div
                                  key={index}
                                  className="d-flex align-items-center justify-content-between my-2 py-2"
                                >
                                  <span className="top_startgy_inbottomadvance">
                                    {/* {truncateText(,18)} */}
                                    {truncateText(login.message, 18)}
                                    {/* {login.message} */}
                                  </span>
                                  <span className="noti_inner_right">
                                    {dayjs(login.createdAt).fromNow()}
                                  </span>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </Menu>
                    </div>
                  ) : null}

                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    className={` m-0 p-0 ${classes.mobileMenuButton} ${classes.drawerIcon}`}
                  >
                    <MenuIcon className="meus" onClick={handleMobileMenuOpen} />
                  </IconButton>
                </div>
             
              </Toolbar>
            </AppBar>

            <Drawer
              anchor="left"
              open={mobileMenuOpen}
              onClose={handleMobileMenuClose}
              className={`mobile-drawer ${classes.drawer}`}
            >
              <div className={classes.mobileMenu}>
                <div className="logo_new_sectio mobile_menu_icon">
                  <Link to="/" className="logo-brand">
                    <img src={Logo} className="img-fluid" alt="logo" />
                  </Link>
                </div>

                <div className="menu_statis">
                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/home" : "/"}>
                      {t("Home")}
                    </Link>
                  </ListItem>
                  {/* <ListItem button className="drawa">
                    {user.isAuthenticated ? (
                      <Link to={user.isAuthenticated ? "/strategies" : "/"}>
                        Strategies
                      </Link>
                    ) : (
                      <Link
                        onClick={walletneed}
                        to={user.isAuthenticated ? "/" : "/"}
                      >
                        Strategies
                      </Link>
                    )}
                  </ListItem> */}
                  {/* {loginCheck ? (
                    <ListItem button className="drawa ">
                      <Link to={user.isAuthenticated ? "/assets" : "/"}>
                        {t("Assets")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )} */}

                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link to={user.isAuthenticated ? "/deposit" : "/"}>
                        {t("Deposit")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}
                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link to={user.isAuthenticated ? "/transferwallet" : "/"}>
                        {t("Transfer")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link to={user.isAuthenticated ? "/upgrade" : "/"}>
                        {t("Upgrade")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {/* <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/strategies" : "/"}>
                      {t("Strategies")}
                    </Link>
                  </ListItem> */}

                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link to={user.isAuthenticated ? "/apibind" : "/"}>
                        {t("APIBinding")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link
                        to={user.isAuthenticated ? "/bottradehistory" : "/"}
                      >
                        {t("BotTrade")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link
                        to={user.isAuthenticated ? "/balance-history" : "/"}
                      >
                        {t("BotBalance")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link to={user.isAuthenticated ? "/withdraw" : "/"}>
                        {t("Withdraw1")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}
                  {loginCheck ? (
                    <ListItem button className="drawa">
                      <Link to={user.isAuthenticated ? "/referral" : "/"}>
                        {" "}
                        {t("ReferEarn")}
                      </Link>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {/* <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/" : "#how-it-works"}>
                      {t("HowItWorks")}
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <a to={user.isAuthenticated ? "" : "#pricing"}>
                      {t("Pricing")}
                    </a> */}
                  {/* </ListItem> */}
                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "" : "/about-us"}>
                      {t("Aboutus")}
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/" : "/affiliate"}>
                      {t("Affiliate")}
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/" : "/faq"}>
                      {t("FAQ")}
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/" : "/guides-tutorials"}>
                      {t("GuidesTutorials")}
                    </Link>
                  </ListItem>

                  {/* <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/" : "/contact"}>
                      {t("Contact10")}
                    </Link>
                  </ListItem> */}

                  {/* <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/team" : "/"}>
                      {" "}
                      Your Team
                    </Link>
                  </ListItem> */}

                  {user.isAuthenticated ? (
                    <>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/profile" : "/"}>
                          {" "}
                          {t("Profile")}
                        </Link>
                      </ListItem>
                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/deposit" : "/"}>
                          {" "}
                          Deposit
                        </Link>
                      </ListItem> */}

                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/apibind" : "/"}>
                          {" "}
                          API Bind
                        </Link>
                      </ListItem> */}
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/security" : "/"}>
                          {" "}
                          {t("Security")}
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/faq" : "/"}>
                          {" "}
                          {t("FAQs")}
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/policy" : "/"}>
                          {" "}
                          {t("Policy")}
                        </Link>
                      </ListItem>
                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/team" : "/"}>
                          Your Team
                        </Link>
                      </ListItem> */}
                      {/* <ListItem button className="drawa">
                        <Link
                          to={user.isAuthenticated ? "/transferwallet" : "/"}
                        >
                          Transfer
                        </Link>
                      </ListItem> */}
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/history" : "/"}>
                          {" "}
                          {t("History")}
                        </Link>
                      </ListItem>
                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/poolhistory" : "/"}>
                          {" "}
                          Pool
                        </Link>
                      </ListItem> */}
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/support" : "/"}>
                          {t("Support")}
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        {!user.isAuthenticated ? (
                          <Link to="/login">
                            <button
                              className="head-btn-login now_log"
                              style={{ width: "150px" }}
                            >
                              <span className="head-btn-login-now now_log">
                                {t("Login")}
                              </span>
                              <span className="head-btn-login-new">
                                {t("Login")}
                              </span>
                            </button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </ListItem>
                      <ListItem button className="drawa">
                        {!user.isAuthenticated ? (
                          <Link to="/register">
                            <button
                              className="head-btn-login"
                              style={{ width: "150px" }}
                            >
                              <span className="head-btn-login-now">
                                {t("Registerpage")}
                              </span>
                              <span className="head-btn-login-new">
                                {t("Registerpage")}
                              </span>
                            </button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </ListItem>
                      <ListItem button className="drawa">
                        {user.isAuthenticated ? (
                          <Link>
                            <button
                              className="head-btn-login mx-2"
                              style={{ width: "150px" }}
                              onClick={handleLogout}
                            >
                              <span className="head-btn-login-now">
                                {t("Logout")}
                              </span>
                              <span className="head-btn-login-new">
                                {t("Logout")}
                              </span>
                            </button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </ListItem>
                    </>
                  ) : (
                    ""
                  )}
                  {headerLoader == true ? (
                    ""
                  ) : !user.isAuthenticated ? (
                    <>
                      <Link to="/login">
                        <button
                          className="head-btn-login mx-2"
                          style={{ width: "150px" }}
                        >
                          <span className="head-btn-login-now">
                            {t("Login")}
                          </span>
                          <span className="head-btn-login-new">
                            {t("Login")}
                          </span>
                        </button>
                      </Link>
                      <Link to="/register">
                        <button
                          className="head-btn-login mt-2 mx-2"
                          style={{ width: "150px" }}
                        >
                          <span className="head-btn-login-now">
                            {t("Registerpage")}
                          </span>
                          <span className="head-btn-login-new">
                            {t("Registerpage")}
                          </span>
                        </button>
                      </Link>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Drawer>

            {emailPopup && (
              <div
                className="modal fade show email_modal"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header lvl-one-header email_missing_header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        {t("EmailUpdate")}
                      </h1>

                      <span className="btn-close-new" onClick={closePopup}>
                        X
                      </span>
                    </div>
                    <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                      <div className="mt-2 d-flex flex-column gap-3">
                        <div className="profile_edit_inpmain">
                          <span className="home-viewasset-span">
                            <h1 className="email_header">
                              {t("YourEmailIsMissing")}
                            </h1>
                            <p>{t("EmailNoticed")}</p>
                            <p>{t("EmailClickBtn")}</p>
                          </span>
                        </div>
                        <div className="update-email">
                          <button
                            className="btn profile_savebtn"
                            onClick={proceedToProfile}
                          >
                            {t("UpdateEmail")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {verifyEmailPopup && (
              <div
                className="modal fade show email_modal"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header lvl-one-header email_missing_header">
                      <h1 className="modal-title fs-5">
                        {t("VerifyYourEmail")}
                      </h1>
                      <span
                        className="btn-close-new"
                        onClick={closeVerifyPopup}
                      >
                        X
                      </span>
                    </div>
                    <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                      <div className="mt-2 d-flex flex-column gap-3">
                        <div className="profile_edit_inpmain">
                          <span className="home-viewasset-span">
                            <h1 className="email_header">
                              {t("YourEmailIsNotVerified")}
                            </h1>
                            <p>{t("EmailVerified")}</p>
                            <p>{t("EmailVerifyClick")}</p>
                          </span>
                        </div>
                        <div className="update-email">
                          <button
                            className="btn profile_savebtn"
                            onClick={proceedToProfile}
                          >
                            {t("VerifyEmail")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {notificationPopup && (
              <div
                className="modal fade show email_modal"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header lvl-one-header email_missing_header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        {t("NotificationUpdate")}
                      </h1>

                      <span className="btn-close-new" onClick={close_popup}>
                        X
                      </span>
                    </div>
                    <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                      <div className="mt-2 d-flex flex-column gap-3">
                        <div className="profile_edit_inpmain">
                          <span className="home-viewasset-span">
                            <h1 className="email_header">{t("Notify")}</h1>
                            <p>{AdminNotificationref.current.message}</p>
                          </span>
                        </div>
                        <div className="update-email">
                          <button
                            className="btn profile_savebtn"
                            onClick={close_popup}
                          >
                            {t("Close")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Joyride
              steps={steps}
              run={run}
              continuous={true}
              showProgress={true}
              showSkipButton={true}
              showBackButton={true}
              callback={(data) => {
                if (data.status === "finished" || data.status === "skipped") {
                  setRun(false);
                  localStorage.removeItem("userlogin"); // Remove first login flag

                  // **Step 3: Check Email Conditions After Joyride**
                  const userEmail = localStorage.getItem("useremail") || "";
                  const hasSeenEmailPopup =
                    localStorage.getItem("hasSeenEmailPopup");

                  if (!userEmail || userEmail === "N/A") {
                    setEmailPopup(true);
                    localStorage.setItem("hasSeenEmailPopup", "true"); // Mark email popup as seen
                  } else {
                    if (user.emailStatus == 0) {
                      localStorage.setItem("hasSeenEmailVerifyPopup", "false");
                      setVerifyEmailPopup(true);
                    }
                  }
                }
              }}
              locale={{
                last: "Done",
                next: "Next",
                back: "Back",
                skip: "Skip",
              }}
              styles={{
                options: {
                  zIndex: 1000,
                  primaryColor: "#007bff",
                  textColor: "#333",
                  overlayColor: "rgba(0, 0, 0, 0.5)",
                  backgroundColor: "#fff",
                  width: 400,
                },
                buttonSkip: {
                  backgroundColor: "transparent",
                  color: "rgb(206, 179, 8)",
                  fontWeight: "bold",
                  fontSize: "14px",
                  border: "none",
                  padding: "6px 12px",
                },
                buttonNext: {
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  fontSize: "14px",
                  padding: "8px 10px",
                  border: "1px solid #ccc",
                },
                buttonBack: {
                  backgroundColor: "transparent",
                  color: "rgb(206, 179, 8)",
                  fontWeight: "bold",
                  border: "none",
                  padding: "6px 12px",
                  fontSize: "14px",
                },
                tooltip: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                },
                tooltipFooter: {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                },
                buttonClose: {
                  color: "#eaecef",
                },
              }}
            />
          </div>
        </div>

        {/* <div className="cookies_wrap">
          <CookieConsent
            location="bottom"
            buttonText="Accept Cookies"
            cookieName="myAwesomeCookieName2"
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            expires={150}
          >
            <div>
              <p className="cookies_content">
                We use cookies to ensure the best possible experience. By using
                our site you agree with our{" "}
                <a
                  href="/privacy-cookies-policy"
                  target="_blank"
                  className="cookies_link"
                >
                  Cookie Policy
                </a>
              </p>
            </div>
          </CookieConsent>
        </div> */}
        <div className="cookies_wrap">
          <CookieConsent
            location="bottom"
            buttonText="Accept Cookies"
            declineButtonText="Decline Cookies"
            cookieName="myAwesomeCookieName2"
            enableDeclineButton
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            declineButtonStyle={{
              color: "#ff0000",
              fontSize: "13px",
              marginLeft: "10px",
            }}
            expires={150}
            // onDecline={() => {
            //   console.log("Cookies declined");
            // }}
          >
            <div>
              <p className="cookies_content">
                {t("cookiecontent")}{" "}
                <a
                  href="/privacy-cookies-policy"
                  target="_blank"
                  className="cookies_link"
                >
                  {t("CookiePolicy")}
                </a>
              </p>
            </div>
          </CookieConsent>
        </div>
      </header>
    </div>
  );
}

export default Header;
